import type { AppointmentDTO } from 'src/types/dto/appointment.dto';

import dayjs from 'dayjs';

export const getEarliestActivityAppointment = (
  appointments?: AppointmentDTO[]
): AppointmentDTO | undefined =>
  appointments
    ?.filter((appointment) => appointment.type !== 'blocker')
    .sort((a, b) => dayjs(a.from).valueOf() - dayjs(b.from).valueOf())[0];
